module.exports = __webpack_public_path__ + "static/media/compare-vehicle-screenshot.7fe59c3c.png";